import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { TextField, Box } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import gradients from 'utils/gradients';
import { useMutation, useApolloClient } from '@apollo/react-hooks';
import { loader } from 'graphql.macro';
import { useHistory } from 'react-router';
import Base from './Base';
import ButtonWithCircularProgress from 'components/ButtonWithCircularProgress';

const ResetPasswordMutation = loader('graphql/mutations/ResetPassword.graphql');

const useStyles = makeStyles(theme => ({
    icon: {
        backgroundImage: gradients.green,
        color: theme.palette.white,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
        position: 'absolute',
        top: -32,
        left: theme.spacing(3),
        height: 64,
        width: 64,
        fontSize: 32
    },
    loginForm: {
        marginTop: theme.spacing(3)
    },
    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }
    }
}));

const UsersResetPassword = () => {
    const code = new URL(window.location.href).searchParams.get('code');
    const classes = useStyles();
    const client = useApolloClient();
    const history = useHistory();
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [resetPassword, { loading }] = useMutation(ResetPasswordMutation, {
        onCompleted: () => {
            client.writeData({ data: { isConnected: true } });
            history.push('/');
        },
        onError: () => {
            history.push('/');
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        resetPassword({ variables: { input: { token: code, password: password } } });
    };

    return (
        <Base title="Changer mon mot de passe" subtitle="Changer mon mot de passe" icon={<LockIcon className={classes.icon} />}>
            <form className={classes.loginForm} onSubmit={handleSubmit}>
                <div className={classes.fields}>
                    <TextField fullWidth label="Nouveau mot de passe" name="password" type="password" variant="outlined"
                        value={password} onChange={e => setPassword(e.target.value)} 
                        error={password.length < 8} helperText={password.length < 8 ? "Le mot de passe doit faire minimum 8 caractères.": null} />
                    <TextField fullWidth label="Confirmer le mot de passe" name="passwordConfirm" type="password" variant="outlined"
                        value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)}
                        error={password !== passwordConfirm} helperText={password !== passwordConfirm ? "Le mot de passe ne correspond pas.": null} />
                </div>
                <Box marginTop={2}>
                    <ButtonWithCircularProgress size="large" type="submit" loading={loading} disabled={password === "" || passwordConfirm === "" || loading || password.length < 8 || password !== passwordConfirm}
                        label="Changer mon mot de passe" fullWidth />
                </Box>
            </form>
        </Base>
    );
};

export default UsersResetPassword;